module.exports = __webpack_public_path__ + "static/media/Amiri-Regular.21e6d71c.ttf";